module.exports = __webpack_public_path__ + "img/reports-price-distribution.d75d25bd.jpg";